import { Component, Inject, OnDestroy } from '@angular/core';
import { UserDetailsFragment, UserDetailsGQL } from "@/core/graphql/graphql";
import { catchError, tap } from "rxjs/operators";
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CosmosDialogService } from "@/core/services/cosmos-dialog.service";

@Component({
  selector: 'cosmos-user-details',
  templateUrl: './user-details-modal.component.html',
  styleUrls: ['./user-details-modal.component.scss'],
})
export class UserDetailsModalComponent implements OnDestroy {
  public _user: UserDetailsFragment;
  private readonly _sub = new Subscription();

  public constructor(
    private readonly _modalRef: MatDialogRef<UserDetailsModalComponent>,
    private readonly _userDetailsGql: UserDetailsGQL,
    private readonly _dialog: CosmosDialogService,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { userId: number },
  ) {
    this._sub.add(this._userDetailsGql.watch({ id: this._data.userId }, {
      errorPolicy: 'all',
    }).valueChanges
      .pipe(
        tap(x => {
          this._user = x.data.fullUser;
        }),
        catchError(async () => this._modalRef.close()),
      ).subscribe());
  }

  public ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  public closeDetails(): void {
    this._modalRef.close();
  }
}
